import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ServicioImprimirAdmisionService, ParametrosImprimirAdmisionEntity, EmpresaAdmision, EntidadEmpresarial,
  InformacionUsuarioEntity, FiltrosImprimirAdmisionEntity,
  InformacionAfiliadoEntity, ReporteAdmisionEntity, InformacionDetalleAdmisionEntity,
  InformacionAnticipoAdmisionEntity } from '../../../../../services/servicio-imprimir-admision.service';
import { SelectItem } from 'primeng/api';
import { HttpErrorResponse } from '@angular/common/http';
import { FileService } from '../../../../../services/utils/file.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-header-imprimir-admision',
  templateUrl: './header-imprimir-admision.component.html',
  styleUrls: ['./header-imprimir-admision.component.css']
})

export class HeaderImprimirAdmisionComponent implements OnInit {
  loading: boolean;
  mostrarReporte: boolean;
  mensaje: string;

  canDownload: boolean;
  downloading: boolean;

  empresa: string;
  empresas: EmpresaAdmision[];
  empresasItem: SelectItem[] = [];
  empresaSelected: number;

  ocultarDetalle: boolean;
  ocultarDetalleItem: SelectItem[] = [];
  ocultarDetalleSelected: boolean;

  mensajeError: string;

  entidad: EntidadEmpresarial;
  usuario: InformacionUsuarioEntity;
  afiliado: InformacionAfiliadoEntity;

  @Input() public objetoParametros: ParametrosImprimirAdmisionEntity;
  @Input() public objetoFiltros: FiltrosImprimirAdmisionEntity;
  @Output() emitData: EventEmitter<ReporteAdmisionEntity>;
  @Output() emitError: EventEmitter<string>;
  @Output() emitLoading: EventEmitter<any>;

  constructor(private servicioImprimirAdmision: ServicioImprimirAdmisionService,
    private servicioArchivo: FileService) {
    this.loading = true;
    this.downloading = false;
    this.emitData = new EventEmitter();
    this.emitError = new EventEmitter();
    this.emitLoading = new EventEmitter();
    this.ocultarDetalleSelected = false;
    this.ocultarDetalleItem = [{ label: 'Si', value: true }, { label: 'No', value: false }];
  }

  ngOnInit() {
    this.getEmpresasAdmision();
  }

  async getEmpresasAdmision() {
    try {
      const response = await this.servicioImprimirAdmision.getEmpresasAdmision(this.objetoParametros);
      if (response != null) {
        response.subscribe((data: EmpresaAdmision[]) => {
          this.empresas = data;
          this.empresasItem = [];
          data.forEach((e: EmpresaAdmision) => {
            this.empresasItem.push({ label: e.descripcionEmpresa, value: e.uncoAdmisionEmpresa });
          });
          this.empresaSelected = -1;
          this.getEntidadEmpresarial();
        }, (err: HttpErrorResponse) => {
          console.log('Error getEmpresasAdmision', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener empresas de la admisión, reporte caso al administrador');
        });
      }
    } catch (e) {
      console.error(e);
    }
  }

  async getEntidadEmpresarial() {
    try {
      const response = await this.servicioImprimirAdmision.getEntidadEmpresarial(this.objetoParametros);
      if (response != null) {
        response.subscribe((data: any) => {
          if (data && Array.isArray(data) && data.length > 0) {
            data = data[0];
            const entidad: EntidadEmpresarial = {
              identificacionTributaria: data.identificacionTributaria,
              digitoVerificacion: data.digitoVerificacion,
              descripcion: data.descripcion,
              direccion: data.direccion,
              telefono: data.telefono,
              logoUrl: data.urlLogo,
              codigoPrestador: data.codigoPrestador,
            };
            this.entidad = entidad;
            this.getInformacionUsuario();
          }
        }, (err: HttpErrorResponse) => {
          console.log('Error entidad Empresarial', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información de la entidad empresarial, reporte caso al administrador');
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getInformacionUsuario() {
    try {
      const response = await this.servicioImprimirAdmision.getInformacionUsuario(this.objetoParametros);
      if (response != null) {
        response.subscribe((data: any) => {
          data = data[0];
          this.usuario  = {
            nombreUsuario: data.nombreUsuario,
            codigoBarrasImprime: data.codigoBarrasImprime,
          };
          this.getInformacionAfiliado();
        }, (err: HttpErrorResponse) => {
          console.log('Error Info usuario', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información del usuario, reporte caso al administrador');
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getInformacionAfiliado() {
    try {
      const response = await this.servicioImprimirAdmision.getInformacionAfiliado(this.objetoParametros, this.objetoFiltros);
      if (response != null) {
        response.subscribe((data: any) => {
          data = data[0];
          const afiliado: InformacionAfiliadoEntity = {
            consecutivoAdmision: data.consecutivoAdmision,
            descripcionEmpresa: data.descripcionEmpresa,
            descripcionEstadoAdmision: data.descripcionEstadoAdmision,
            descripcionEstratoAfiliado: data.descripcionEstratoAfiliado,
            descripcionSede: data.descripcionSede,
            descripcionTipoAfiliado: data.descripcionTipoAfiliado,
            direccionAfiliado: data.direccionAfiliado,
            edad: data.edad,
            fechaAdmision: data.fechaAdmision,
            fechaNacimiento: data.fechaNacimiento,
            nombreAfiliado: data.nombreAfiliado,
            numeroIdentificacionAfiliado: data.numeroIdentificacionAfiliado,
            telefonoAfiliado: data.telefonoAfiliado,
            uncoSede: data.uncoSede,
            valorTotalAtencion: data.valorTotalAtencion,
            ValorTotalIva: data.ValorTotalIva,
            ValorTotalServicios: data.ValorTotalServicios,
            ValorTotalSuministros: data.ValorTotalSuministros,
          };
          this.afiliado = afiliado;
          this.onGenerar();
        }, (err: HttpErrorResponse) => {
          console.log('Error Info afiliado', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener información del afiliado, reporte caso al administrador');
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  async getDetallesAdmision(dataReporte: ReporteAdmisionEntity) {
    try {
      const response = await this.servicioImprimirAdmision.getInformacionAdmision(this.objetoParametros);
      if (response != null ) {
        response.subscribe((data: InformacionDetalleAdmisionEntity[]) => {
          dataReporte.detalleAdmision = data;
          this.getAnticiposAdmision(dataReporte);
        }, (err: HttpErrorResponse) => {
          console.log('Error getEmpresasAdmision', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener detalles de la admisión, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener detalle de la admisión, reporte caso al administrador');
    }
  }

  async getAnticiposAdmision( dataReporte: ReporteAdmisionEntity) {
    try {
      const response = await this.servicioImprimirAdmision.getInformacionAnticipos(this.objetoParametros);
      if (response != null) {
        response.subscribe((data: InformacionAnticipoAdmisionEntity[]) => {
          dataReporte.anticipos = data;
          this.emitData.emit(dataReporte);
        }, (err: HttpErrorResponse) => {
          console.error('Error getAnticiposAdmision', err);
          this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos de los anticipos, reporte caso al administrador');
        });
      }
    } catch (e) {
      this.emitError.emit('<i class="fa fa-warning"></i> Error grave al obtener datos de los anticipos, reporte caso al administrador');
    }
  }

  async onGenerar() {
    const empresaSeleccionada = this.empresas.find((e: EmpresaAdmision) => {
      return e.uncoAdmisionEmpresa === this.empresaSelected;
    });

    const dataReporte: ReporteAdmisionEntity = {
      entidad: this.entidad,
      empresa : empresaSeleccionada,
      usuario: this.usuario,
      afiliado: this.afiliado,
      detalle : this.ocultarDetalleSelected ? 0 : 1,
      detalleAdmision : [],
      anticipos: []
    };

    this.objetoParametros.uncoAdmisionEmpresa = this.empresaSelected.toString();
    this.emitLoading.emit();
    this.getDetallesAdmision(dataReporte);
  }

  onImprimir() {
    let printContents: any, popupWin: any;

    printContents = document.getElementById('admision-print').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto,menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes');
    popupWin.document.open();

    popupWin.document.write(`
      <html>
        <head>
          <title> Standard Health | Reportes </title>
          <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css"
          integrity="sha384-MCw98/SFnGE8fJT3GXwEOngsV7Zt27NXFoaoApmYm81iuXoPkFOJwJ8ERdknLPMO" crossorigin="anonymous">
          <style>
            /* Tamaños fuentes */

            .font-title {
                font-size: 150px;
            }

            .font-subtitle {
                font-size: 30px;
            }

            .font-normal {
                font-size: 16px;
            }
          </style>
        </head>
        <body onload="window.print();window.close()">${ printContents }</body>
      </html>`
    );

    popupWin.document.close();
  }

  // Se inactiva opción de descargar pdf
  onDescargarPDF() {
    /*try {
      this.downloading = true;
      const data = xepOnline.Formatter.Html('admision-print', { resolution : '200'});
      const html = `<!DOCTYPE html><head><meta charset="UTF-8"/><title>Citas Laboratorio</title></head><body>${data}</body></html>`;
      const response = this.servicioArchivo.generatePDF(html, 'Impresión Admisión', 'impresionAdmision');

      response.subscribe(( pdf: any) => {
        const filename = pdf.filename;
        this.servicioArchivo.downloadFile(filename)
        .subscribe((down: any) => {
          saveAs(down, filename);
          this.downloading = false;
        }, err => {
          // this.mostrarMensaje('Error al intentar generar PDF, reporte caso inmediatamente a su administrador.');
          console.error('Error download', err);
          this.downloading = false;
        });
      }, (err: HttpErrorResponse) => {
        console.error('Error', err);
        // this.mostrarMensaje('La generación PDF no se encuentra funcionando, reporte caso inmediatamente a su administrador.');
        this.downloading = false;
      });
    } catch (e) {
      console.error('Excepcion descargando pdf', e);
    }*/
  }

}
